import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { importUsersApi } from '../../api/admin/scr'

import { createUser, ErrorResponse } from '../../utils/types'
import { Icon } from '../Icon'
import UIButton from './UIButton'

type UserData = {
  firstName: string
  lastName: string
  email: string
  // dateOfBirth: string
  role: string
}

const UploadCSV: React.FC = () => {
  const [csvData, setCsvData] = useState<UserData[]>([])

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (e.target) {
          const contents = e.target.result as string
          parseCSV(contents)
        }
      }
      reader.readAsText(file)
    }
  }

  const parseCSV = (csvContent: string) => {
    const lines = csvContent.split(/\r\n|\n/)
    const headers = lines[0].split(',')

    const parsedData: UserData[] = []

    for (let i = 1; i < lines.length; i++) {
      const data = lines[i].split(',')
      if (data.length === headers.length) {
        const userData: UserData = {
          firstName: data[0],
          lastName: data[1],
          email: data[2],
          // dateOfBirth: data[3],
          role: data[3],
        }
        parsedData.push(userData)
      }
    }

    setCsvData(parsedData)
  }

  const handleDeleteRow = (index: number) => {
    const updatedData = [...csvData]
    updatedData.splice(index, 1)
    setCsvData(updatedData)
  }

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileUpload({
        target: {
          files: e.dataTransfer.files,
        },
      } as React.ChangeEvent<HTMLInputElement>)
    }
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFileUpload(event)
  }

  const downloadSampleCSV = () => {
    const headers = ['firstName', 'lastName', 'email', 'role']
    const rows = [
      ['John', 'Doe', 'john.doe@example.com', 'Admin'],
      ['Jane', 'Smith', 'jane.smith@example.com', 'Staff'],
      ['Alice', 'Johnson', 'alice.johnson@example.com', 'Staff'],
      ['Bob', 'Lee', 'bob.lee@example.com', 'Staff'],
      ['Carol', 'White', 'carol.white@example.com', 'Safeguarding Lead'],
    ]
    const csvContent = `data:text/csv;charset=utf-8,${headers.join(',')}\n${rows
      .map((row) => row.join(','))
      .join('\n')}`
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'sample.csv')
    document.body.appendChild(link) // Required for FF
    link.click()
    document.body.removeChild(link)
  }

  const ImportUser = async (): Promise<void> => {
    try {
      const response = (await importUsersApi(csvData)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        toast.success('Sent Email to users.', {
          position: 'top-right',
        })
        // setIsLoading(false)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
        // setIsLoading(false)
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  return (
    <div>
      <div
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        className="w-full p-5 py-3 gap-3 bg-gray1 rounded-xl flex border-2 border-dashed border-gray3 border-separate border-spacing-3"
      >
        <div className="flex flex-1 items-center gap-2">
          <Icon
            name={'IconUploadCloud'}
            stroke={'#02698C'}
            strokeWidth={1.5}
            height={20}
            width={20}
          />
          <p className="font-medium text-xs leading-5 text-text1">
            Drop your file here or
          </p>
        </div>
        <label htmlFor="fileInput">
          <div className="cursor-pointer flex items-center gap-2 bg-bluishGreen p-4 py-3 rounded-full">
            <Icon
              name={'IconUploadCloud'}
              stroke={'#FFFFFF'}
              strokeWidth={1.5}
              height={20}
              width={20}
            />
            <p className="font-medium text-xs leading-5 text-text8">
              Choose a file to upload
            </p>
            <input
              id="fileInput"
              type="file"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept={'.csv'}
            />
          </div>
        </label>
      </div>

      <div className="overflow-hidden rounded-[16px] w-full mt-[5px]">
        <table className="rounded-[16px] overflow-hidden border w-full border-white">
          <thead>
            <tr className="bg-gray2">
              <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  firstName
                </p>
              </th>
              <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  lastName
                </p>
              </th>
              <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  email
                </p>
              </th>
              {/* <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  DOB
                </p>
              </th> */}
              <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  User Role
                </p>
              </th>
              <th className={` px-4 py-3 text-left  'border border-white'}`}>
                <p className="text-text1 font-semibold text-[10px] flex-1">
                  Action
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {csvData.map((user, index) => (
              <tr className="bg-gray1" key={index}>
                <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  {user.firstName}
                </td>
                <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  {user.lastName}
                </td>
                <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  {user.email}
                </td>
                {/* <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  {user.dateOfBirth}
                </td> */}
                <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  {user.role}
                </td>
                <td className="px-4 text-text1 font-medium text-[10px] h-[48px] py-2 border border-white">
                  <div onClick={() => handleDeleteRow(index)}>
                    <Icon
                      name={'IconTrash'}
                      stroke={'#FF6666'}
                      strokeWidth={1.5}
                      height={20}
                      width={20}
                    />
                  </div>
                  {/* <button onClick={() => handleDeleteRow(index)}>Delete</button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="w-full mt-3 space-y-3">
        <UIButton
          secondary={true}
          label={'  Download Sample CSV'}
          onClick={downloadSampleCSV}
        />
        <UIButton
          label={'Create'}
          onClick={() => {
            ImportUser()
          }}
        />
      </div>
    </div>
  )
}

export default UploadCSV
